angular.module('hjApp.ui').component('npsTrademarkMessage', {
    template: require('./nps-trademark-message.component.html')
});
